import React from "react";
import ReactDOM from "react-dom";
import icons from "../../../../../assets/images/icons";
import { useEscapeClose } from "../../../../../common/hooks/useEscapeClose";
import styles from "./ChatManageModal.module.scss";

/**
 * 채팅관리 모달 — 전송 실패 메시지 재전송/삭제 선택
 * Figma: 40005399:339103
 */
function ChatManageModal({ open, onClose, onRetry, onDelete }) {
  useEscapeClose(onClose, open);

  if (!open) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose?.();
  };

  return ReactDOM.createPortal(
    <div
      className={styles.overlay}
      onClick={handleOverlayClick}
      role="dialog"
      aria-modal="true"
      aria-labelledby="chat-manage-modal-title"
      data-node-id="40005399:339103"
    >
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.nav}>
          <h2 id="chat-manage-modal-title" className={styles.title}>
            메시지 관리
          </h2>
          <button type="button" className={styles.closeBtn} onClick={onClose} aria-label="닫기">
            <img src={icons.messager?.close} alt="" className={styles.closeIcon} />
          </button>
        </div>
        <div className={styles.actionArea}>
          <div className={styles.actions}>
            <button type="button" className={styles.retryBtn} onClick={onRetry}>
              재전송
            </button>
            <button type="button" className={styles.deleteBtn} onClick={onDelete}>
              삭제
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}

export default ChatManageModal;
